import { useCallback } from 'react'

import { buildNotetakerEtToggleUpdatePayload } from 'features/growth_experiments'
import {
  useGetMeetingIntelligenceUserSettingsQuery,
  useUpdateUserMeetingIntelligenceDataMutation,
} from 'features/meeting_intelligence'

export const useSyncNotetakerSettings = () => {
  const { data: meetingIntelligenceSettings, refetch: refetchMeetingIntelligenceSettings } = useGetMeetingIntelligenceUserSettingsQuery()
  const [updateUserMeetingIntelligenceData] = useUpdateUserMeetingIntelligenceDataMutation()

  return useCallback(async ({
    eventTypeId,
    notetakerEnabledForEt,
  }) => {
    if (!eventTypeId || typeof notetakerEnabledForEt !== 'boolean') return

    let miSettings = meetingIntelligenceSettings

    if (!miSettings) {
      try {
        const refetchResult = await refetchMeetingIntelligenceSettings()
        miSettings = refetchResult?.data
      } catch (_error) {
        return
      }
    }

    if (!miSettings) return

    const payload = buildNotetakerEtToggleUpdatePayload({
      eventTypeId,
      enabledForEventType: notetakerEnabledForEt,
      miSettings,
    })

    if (!payload) return

    try {
      await updateUserMeetingIntelligenceData(payload).unwrap()
    } catch (_error) {
      // The event type save has already succeeded; MI update failure should not block the user.
    }
  }, [
    meetingIntelligenceSettings,
    refetchMeetingIntelligenceSettings,
    updateUserMeetingIntelligenceData,
  ])
}
